/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback, useRef } from "react";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth } from "firebase/auth";
import PetCard from "./PetCard";
import Map from "../pets/Map";
import Notification from "../Notification";
import "../../index.css";
import { format } from "date-fns";
import {
  getSingleUserData,
  getPetById,
  updateSinglePet,
  uploadPetCard,
  updateSingleDoc,
} from "../../utils";
import { v4 } from "uuid";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CropEasy from "../Crop/CropEasy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

export const CompartirMascota = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const currentUser = auth.currentUser;
  const currentDate = new Date();
  const formattedDate = format(currentDate, "dd/MM/yyyy");
  const db = getFirestore();
  const colRef = collection(db, "mascota");
  const storage = getStorage();
  const [userData, setUserData] = useState(null);
  const [edit, setEdit] = useState(false);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const timeoutRef = useRef([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [file, setFile] = useState(null);
  const [toWebp, setTowebp] = useState(null);
  const [readyPet, setReadyPet] = useState(false);
  const [newPetId, setNewPetId] = useState(null);
  const edadCategories = [
    { min: 0, max: 4, texto: "Cachorro" },
    { min: 5, max: 8, texto: "Joven" },
    { min: 9, max: 16, texto: "Anciano" },
  ];
  const estadoMap = {
    1: "en búsqueda",
    2: "recuperada",
    3: "encontrada",
    4: "en adopción",
  };

  const [catEdad, setCatEdad] = useState("");
  const [qr, setQr] = useState(false);
  const [openCrop, setOpenCrop] = useState(false);
  const [photoURL, setPhotoURL] = useState("");
  //Redux store
  const petFormDataState = useSelector((state) => state.compartirMascota);
  const [queryParamsLoaded, setQueryParamsLoaded] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    lat: "",
    lng: "",
    ciudad: "",
    tamano: "",
    color: "",
    edad: "",
    sexo: "",
    tipo: "",
    raza: "",
    estado: "",
    fecha_perdido: "",
    fecha_publi: formattedDate,
    en_contacto: false,
    contacto: "",
    foto: "",
  });
  const location = useLocation();
  const basePath = "/editar/";
  const identifier = location.pathname.startsWith(basePath)
    ? location.pathname.substring(basePath.length)
    : null;

  const queryParams = new URLSearchParams(location.search);
  const receivedData = Object.fromEntries(queryParams.entries());

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      ...Object.fromEntries(
        Object.entries(receivedData).map(([key, value]) => {
          if (
            (key === "lat" || key === "lng") &&
            value !== "" &&
            !isNaN(value)
          ) {
            return [key, Number(value)];
          }
          if (!isNaN(value) && value !== "") {
            return [key, Number(value)];
          }
          return [key, value];
        }),
      ),
    }));
    setQueryParamsLoaded(true);
  }, []);

  const elementRef = useRef(null);

//Componente de geolocalizacion de JS
//Obtener ubicación inicial
useEffect(() => {
  if (!queryParamsLoaded) return;

  const latOk =
    formData.lat !== "" &&
    formData.lat !== null &&
    !isNaN(Number(formData.lat));
  const lngOk =
    formData.lng !== "" &&
    formData.lng !== null &&
    !isNaN(Number(formData.lng));

  // si ya hay coords válidas, no hacemos geolocation automática
  if (latOk && lngOk) return;

  if (!navigator.geolocation) {
    // fallback
    setFormData((prev) => ({
      ...prev,
      lat: -34.9011,
      lng: -56.1645,
      ciudad: prev.ciudad || "Montevideo",
    }));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;

      setFormData((prev) => ({
        ...prev,
        lat: latitude,
        lng: longitude,
      }));
    },
    (error) => {
      console.error("Error obteniendo la ubicación: ", error);

      // fallback Montevideo / CITY se encarga el callback de coords
      setFormData((prev) => ({
        ...prev,
        lat: -34.9011,
        lng: -56.1645,
        ciudad: prev.ciudad || "Montevideo",
      }));
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    }
  );
}, [queryParamsLoaded]);

// CLICK EN EL MAPA
useEffect(() => {
  if (!queryParamsLoaded) return;

  const lat = Number(formData.lat);
  const lng = Number(formData.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  let cancelled = false;

  (async () => {
    try {
      const response = await fetch(
        `https://lost-animal-backend-production.up.railway.app/api/reverse-geocode?lat=${lat}&lng=${lng}`
      );
      const data = await response.json();

      let city = "";

      if (Array.isArray(data.results)) {
        for (const result of data.results) {
          for (const component of result.address_components || []) {
            if (component.types?.includes("locality")) {
              city = component.long_name;
              break;
            }
          }
          if (city) break;
        }
      }

      if (!city && data.formatted_address) {
        city = data.formatted_address;
      }

      if (!cancelled) {
        setFormData((prev) => ({
          ...prev,
          ciudad: city,
        }));
      }
    } catch (error) {
      console.error("Error obteniendo ciudad (reverse-geocode):", error);
    }
  })();

  return () => {
    cancelled = true;
  };
}, [queryParamsLoaded, formData.lat, formData.lng]);
  // ...existing code...

  useEffect(() => {
    const fetchPet = async () => {
      try {
        if (identifier && !identifier.includes("/")) {
          // Solo consulta si identifier es válido
          const editablePet = await getPetById(identifier);
          if (editablePet.length > 0) {
            setFormData(editablePet[0]);
            setEdit(true);
          } else {
            setEdit(null);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchPet();
  }, [identifier]);

  useEffect(() => {
    const fetchUser = async () => {
      let timer;

      if (currentUser) {
        const userData = await getSingleUserData(currentUser);
        setUserData(userData);
        setFormData((prevData) => ({
          ...prevData,
          contacto: userData[0].phone || "",
        }));
      }
      if (notification) {
        timer = setTimeout(() => {
          setNotification(null);
        }, 3000);
      }
      return () => {
        clearTimeout(timer);
      };
    };
    fetchUser();
  }, [auth, currentUser, notification]);

  useEffect(() => {
    const requiredFields = [
      "edad",
      "tamano",
      "tipo",
      "color",
      "contacto",
      "raza",
      "sexo",
      "fecha_perdido",
    ];
    const isValid = requiredFields.every((field) => {
      const fieldValue = formData[field];
      return fieldValue !== null && fieldValue !== "";
    });

    setIsFormValid(isValid);

    if (formData.edad !== null) {
      const cat = edadCategories.find(
        (c) => formData.edad >= c.min && formData.edad <= c.max,
      );
      cat ? setCatEdad(cat.texto) : setCatEdad("");
    }
  }, [formData]);

  useEffect(() => {
    if (formData.estado === 4) {
      const today = new Date();
      const yyyyMMdd = today.toISOString().slice(0, 10);
      setFormData((prevData) => ({
        ...prevData,
        fecha_perdido: yyyyMMdd,
      }));
    }
  }, [formData.estado]);
  useEffect(() => {
    if (newPetId) {
      const timer = setTimeout(() => {
        navigate(`/mascota/${newPetId}`);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [newPetId, navigate]);

  useEffect(() => {
    const addPet = async () => {
      try {
        if (readyPet) {
          const docRef = await addDoc(colRef, {
            ...formData,
            userId: userData[0].userid,
            contact_users: [], // array vacío
          });
          setNewPetId(docRef.id);
          setNotification({
            type: "success",
            message: "Mascota subida correctamente.",
          });
        }
      } catch (error) {
        setNotification({
          type: "error",
          message: error.message,
        });
      }
    };
    addPet();
  }, [readyPet]);

  const handleMarkerAdded = useCallback((lat, lng) => {
    setFormData((prevData) => ({
      ...prevData,
      lat,
      lng,
    }));
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;

    if (type === "radio") {
      if (event.target.checked) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: parseInt(value),
        }));
      }
    } else if (type === "date") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      if (name === "descripcion") {
        if (value.length > 1400) return;
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]:
          (type === "number" || (!isNaN(value) && value.trim() !== "")) &&
          name !== "contacto"
            ? parseInt(value)
            : value,
      }));
    }
  };

  const saveCurrUserPhone = async () => {
    try {
      await updateSingleDoc(userData[0].id, formData.contacto);
    } catch (error) {
      console.error("Error saving phone number:", error);
    }
  };

  const saveDefaultPetName = () => {
    const estadoNombre = estadoMap[formData.estado] || "";
    return `Mascota ${estadoNombre}`;
  };

  const handleUpload = async () => {
    setLoading(true);
    setQr(true); //Imagen sin bordes para descargar o subir a redes
    const loadingMessages = [
      { text: "Preparando a tu amigo...", duration: 4000 },
      { text: "Subiendo a nuestras redes...", duration: 4500 },
      { text: "Dando los últimos retoques...", duration: 3000 },
    ];

    let cumulativeDelay = 0;
    timeoutRef.current.forEach(clearTimeout);
    timeoutRef.current = [];

    loadingMessages.forEach((msg) => {
      const timeoutId = setTimeout(() => {
        setLoadingMessage(msg.text);
      }, cumulativeDelay);
      timeoutRef.current.push(timeoutId);
      cumulativeDelay += msg.duration;
    });

    setTimeout(async () => {
      try {
        if (!userData?.[0]?.userid) {
          setTimeout(() => {
            navigate(`/perfil`);
          }, 3000);

          throw new Error("Usuario no autenticado. Por favor, inicia sesión.");
        }
        if (!formData.lat || !formData.lng) {
          throw new Error(
            "Por favor, activa la geolocalización o selecciona una ubicación en el mapa.",
          );
        }

        if (file) {
          if (isFormValid) {
            const fileRef = ref(storage, `imagenes/${v4()}`);
            await uploadBytes(fileRef, toWebp);
            const urlImg = await getDownloadURL(fileRef);

            // Validar fecha antes de crear el objeto Date
            let formattedDate = "";
            if (formData.fecha_perdido) {
              const date = new Date(formData.fecha_perdido);
              if (!isNaN(date.getTime())) {
                formattedDate = format(date, "dd/MM/yyyy");
              } else {
                throw new Error("La fecha de perdido es inválida.");
              }
            } else {
              throw new Error("Por favor, selecciona una fecha de perdido.");
            }

            setFormData((prevData) => ({
              ...prevData,
              foto: urlImg,
              fecha_perdido: formattedDate,
            }));
          }
        }

        if (!isFormValid) {
          throw new Error("Por favor, completa todos los campos requeridos.");
        }

        if (elementRef && formData.nombre) {
          await uploadPetCard(elementRef, formData.nombre);
        }

        if (userData[0].phone === "") {
          await saveCurrUserPhone();
        }
        if (formData.nombre === "") {
          const defaultName = saveDefaultPetName();
          formData.nombre = defaultName;
          setFormData({ ...formData });
        }

        setFile(null);
        setReadyPet(true);
      } catch (error) {
        setNotification({
          type: "error",
          message: error.message,
        });
      } finally {
        setLoading(false);
        setQr(false); // Desactiva QR al finalizar

        timeoutRef.current.forEach(clearTimeout);
        setLoadingMessage("");
      }
    }, 70);
  };

  const handlePetUpdate = async () => {
    setLoading(true);
    setTimeout(async () => {
      try {
        if (formData.nombre === "") {
          const defaultName = saveDefaultPetName();
          formData.nombre = defaultName;
          setFormData({ ...formData });
        }
        await updateSinglePet(identifier, formData);
        setNotification({
          type: "success",
          message: "Mascota editada correctamente.",
        });
        navigate(`/mascota/${identifier}`);
      } catch (error) {
        setNotification({
          type: "error",
          message: error.message,
        });
      } finally {
        setLoading(false);
      }
    }, 3);
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const maxSize = 2097152; // 2MB
    if (file.size > maxSize) {
      setNotification({
        type: "error",
        message:
          "¡El archivo es demasiado grande! Por favor, elige un archivo más pequeño.",
      });
      event.target.value = "";
      return;
    }

    // Crea un FileReader para leer la imagen
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async () => {
      const image = new Image();
      image.src = reader.result;

      image.onload = async () => {
        // Crear el canvas y dibujar la imagen original
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);

        // Obtener el webpDataUrl de la imagen original
        const webpDataUrl = canvas.toDataURL("image/webp", 1.0);
        const webpBlob = await fetch(webpDataUrl).then((res) => res.blob());

        setPhotoURL(webpDataUrl);
        setFile(webpBlob);
        setOpenCrop(true);
      };
    };
  };

  const onCropComplete = async (croppedFile) => {
    const image = new Image();
    const imageUrl = URL.createObjectURL(croppedFile);
    image.src = imageUrl;

    image.onload = async () => {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, image.width, image.height);
      const webpDataUrl = canvas.toDataURL("image/webp", 1.0);
      const webpBlob = await fetch(webpDataUrl).then((res) => res.blob());
      setTowebp(webpBlob); // Esto actualizaría toWebp con la imagen recortada
      setFormData((prevData) => ({
        ...prevData,
        foto: webpDataUrl,
      }));
    };
  };

  return (
    <div className="flex flex-col w-full px-[15dvw] relative items-center pt-6 bg-orange-50 sm:px-4">
      {openCrop ? (
        <div className="modal-container z-20 bg-black fixed bottom-[10%] w-[50%] h-[80%]  bg-opacity-70">
          <CropEasy
            {...{ photoURL, setOpenCrop, setPhotoURL, setFile, onCropComplete }}
          />
        </div>
      ) : (
        <></>
      )}

      <section className="flex flex-col w-full items-center justify-center gap-5 pb-10">
        <div className="z-10">
          <p className="rounded min-h-[60px] w-fit font-main font-semibold text-center text-4xl uppercase text-white">
            {location.pathname.startsWith("/editar/")
              ? "Editar amigo"
              : "Comparte tu amigo con nosotros"}
          </p>
        </div>

        <section className="flex flex-col h-fit items-center pt-5 gap-6 z-10 w-full">
          <div ref={elementRef}>
            <PetCard data={formData} qr={qr} />
          </div>

          <form
            id="form_file"
            className="border bg-secondary w-fit p-3 rounded-md font-main hover:bg-orange-700"
          >
            <p className="text-white flex justify-center items-center font-main font-bold text-xl uppercase text-center">
              Subir foto
            </p>
            <input
              type="file"
              name="photo"
              id="petPhoto"
              accept="image/*"
              onChange={handleFileChange}
            />
          </form>
        </section>

        <div className="flex flex-col w-full bg-white z-10 p-4 rounded-lg">
          <div className="flex flex-col h-auto gap-6 w-full mb-20">
            <section className="flex flex-row flex-wrap justify-center gap-8 h-full w-full pt-4">
              {/* Primera columna */}
              <div className="flex flex-col gap-8 w-[300px]">
                {/* Nombre */}
                <div className="text-center flex flex-col gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Nombre del amigo
                  </label>
                  <form className="flex items-center justify-center relative h-[60px] w-full font-main font-bold">
                    <input
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      placeholder="Nombre"
                      maxLength={15}
                      onChange={handleInputChange}
                      className="
                  font-main font-medium h-full w-full p-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 shadow-sm"
                    />
                  </form>
                </div>

                {/* Contacto */}
                <div className="text-center flex flex-col gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Teléfono de contacto
                  </label>
                  <form className="flex items-center justify-center relative h-[60px] w-full font-main">
                    <input
                      type="tel"
                      name="contacto"
                      value={formData.contacto}
                      placeholder="Contacto"
                      maxLength={9}
                      onChange={handleInputChange}
                      required
                      className="
                  font-main font-medium h-full w-full p-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 shadow-sm"
                    />
                  </form>
                </div>

                {/* Edad */}
                <div className="text-center flex flex-col gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Edad aproximada
                  </label>
                  <form className="flex items-center justify-center relative h-[60px] w-full font-main">
                    {formData.estado === 1 || formData.estado === 3 ? (
                      // Mostrar select de tipo cuando estado es 1 o 3
                      <>
                        <select
                          name="edad"
                          value={formData.edad}
                          onChange={handleInputChange}
                          className="font-main font-medium h-full w-full pl-6 pr-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 cursor-pointer text-gray-700 shadow-sm"
                        >
                          <option
                            value=""
                            className="font-main text-sm font-normal"
                          >
                            Seleccionar edad
                          </option>
                          <hr></hr>
                          {edadCategories.map((categoria, index) => (
                            <option
                              key={index}
                              value={categoria.max} // Usamos el valor máximo como valor del option
                              className="font-main font-medium border-b-2"
                            >
                              {categoria.texto}
                            </option>
                          ))}
                        </select>
                        <div
                          className="pointer-events-none 
                absolute inset-y-0 right-0 
                flex items-center pr-3
                transition-transform duration-400
                peer-focus:opacity-0"
                        >
                          <FontAwesomeIcon
                            className="h-[2dvh] text-gray-600"
                            icon={faAngleDown}
                          />
                        </div>
                      </>
                    ) : (
                      // Mostrar input de edad para otros estados

                      <div className="flex items-center justify-center relative h-[60px] w-full font-main">
                        <input
                          type="number"
                          name="edad"
                          defaultValue={formData.edad || ""}
                          min="0"
                          max="20"
                          onChange={handleInputChange}
                          required
                          className="
                  font-main font-medium h-full w-full pl-6 pr-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 cursor-pointer text-gray-700 shadow-sm"
                        />
                        {catEdad !== null && (
                          <span className="font-main text-sm absolute top-full left-0 mt-1">
                            {catEdad}
                          </span>
                        )}
                      </div>
                    )}
                  </form>
                </div>
              </div>

              {/* Segunda columna */}
              <div className="flex flex-col gap-8 w-[300px]">
                {/* Raza */}
                <div className="text-center flex flex-col gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Raza
                  </label>
                  <form className="flex items-center justify-center relative h-[60px] w-full font-main">
                    <select
                      name="raza"
                      value={formData.raza}
                      onChange={handleInputChange}
                      required
                      className="font-main font-medium h-full w-full pl-6 pr-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 cursor-pointer shadow-sm"
                    >
                      <option value="" className="font-main font-medium">
                        Seleccionar raza
                      </option>
                      <hr></hr>
                      {petFormDataState.raza.map((option, index) => (
                        <option
                          key={index}
                          value={option.id}
                          className="
                      font-main text-sm font-semibold 
                      text-gray-400 hover:hidden
                      checked:bg-secondary checked:text-white 
                    "
                        >
                          {option.nombre}
                        </option>
                      ))}
                    </select>
                    <div
                      className="
                                      pointer-events-none 
                                      absolute inset-y-0 right-0 
                                      flex items-center pr-3
                                      transition-transform duration-400
                                      peer-focus:opacity-0"
                    >
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className="h-[2dvh] text-gray-600"
                      />
                    </div>
                  </form>
                </div>

                {/* Color */}
                <div className="text-center flex flex-col gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Color o marcas distintivas
                  </label>
                  <form className="flex items-center justify-center relative h-[60px] w-full font-main">
                    <select
                      name="color"
                      value={formData.color}
                      onChange={handleInputChange}
                      required
                      className="
                                      font-main font-medium h-full w-full pl-6 pr-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 cursor-pointer shadow-sm"
                    >
                      <option value="" className="font-main font-medium">
                        Seleccionar color
                      </option>
                      <hr></hr>
                      {petFormDataState.color.map((option, index) => (
                        <option
                          key={index}
                          value={option.id}
                          className="
                                          font-main font-medium
                                          text-gray-400 hover:hidden
                                          checked:bg-secondary checked:text-white 
                                        "
                        >
                          {option.nombre}
                        </option>
                      ))}
                    </select>
                    <div
                      className="pointer-events-none 
                                      absolute inset-y-0 right-0 
                                      flex items-center pr-3
                                      transition-transform duration-400
                                      peer-focus:opacity-0"
                    >
                      <FontAwesomeIcon
                        className="h-[2dvh] text-gray-600"
                        icon={faAngleDown}
                      />
                    </div>
                  </form>
                </div>
                {/* Tamaño */}
                <div className="text-center flex flex-col gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Tamaño
                  </label>
                  <form className="flex items-center justify-center relative h-[60px] w-full font-main">
                    <select
                      name="tamano"
                      value={formData.tamano}
                      onChange={handleInputChange}
                      required
                      className="
                                      font-main font-medium h-full w-full pl-6 pr-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 cursor-pointer shadow-sm"
                    >
                      <option value="" className="font-main font-medium">
                        Seleccionar tamaño
                      </option>
                      <hr></hr>
                      {petFormDataState.tamano.map((option, index) => (
                        <option
                          key={index}
                          value={option.id}
                          className="
                                          font-main font-medium 
                                          text-gray-400 hover:hidden
                                          checked:bg-secondary checked:text-white 
                                        "
                        >
                          {option.nombre}
                        </option>
                      ))}
                    </select>
                    <div
                      className="pointer-events-none 
                                      absolute inset-y-0 right-0 
                                      flex items-center pr-3
                                      transition-transform duration-400
                                      peer-focus:opacity-0"
                    >
                      <FontAwesomeIcon
                        className="h-[2dvh] text-gray-600"
                        icon={faAngleDown}
                      />
                    </div>
                  </form>
                </div>
              </div>

              {/* Tercera columna */}
              <div className="flex flex-col gap-8 w-[300px]">
                {/* Sexo */}
                <div className="text-center flex flex-col items-center gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Sexo
                  </label>
                  <form className="flex font-main">
                    <div className="flex items-center justify-center gap-2">
                      {petFormDataState.sexo.map((option, index) => (
                        <div key={index} className="relative">
                          <input
                            type="checkbox"
                            name="sexo"
                            id={`sexo-${option.id}`}
                            value={option.id}
                            checked={formData.sexo === option.id}
                            onChange={handleInputChange}
                            required
                            className="hidden peer"
                          />
                          <label
                            htmlFor={`sexo-${option.id}`}
                            className="flex items-center font-main font-medium h-[60px] w-[100px] cursor-pointer rounded-lg p-4 justify-center bg-white shadow-md hover:bg-gray-200 peer-checked:bg-secondary peer-checked:text-white sm:w-auto"
                          >
                            {option.nombre}
                          </label>
                        </div>
                      ))}
                    </div>
                  </form>
                </div>

                {/* Tipo de amigo */}
                <div className="text-center flex flex-col items-center gap-1">
                  <label className="font-main font-bold text-lg uppercase">
                    Tipo de amigo
                  </label>
                  <form className="flex font-main">
                    <div className="flex items-center gap-2">
                      {petFormDataState.tipo.map((option, index) => (
                        <div key={index} className="relative">
                          <input
                            type="checkbox"
                            id={`tipo-${option.id}`}
                            name="tipo"
                            value={option.id}
                            checked={formData.tipo === option.id}
                            onChange={handleInputChange}
                            required
                            className="hidden peer"
                          />
                          <label
                            htmlFor={`tipo-${option.id}`}
                            className="flex items-center font-main font-medium h-[60px] w-[100px] cursor-pointer rounded-lg p-4 justify-center bg-white shadow-md hover:bg-gray-200 peer-checked:bg-secondary peer-checked:text-white sm:w-auto"
                          >
                            {option.nombre}
                          </label>
                        </div>
                      ))}
                    </div>
                  </form>
                </div>

                {/* Fecha perdido */}
                {formData.estado !== 4 && (
                  <div className="text-center flex flex-col gap-1">
                    <label className="font-main font-bold uppercase">
                      Fecha de perdido
                    </label>
                    <form
                      className="flex items-center justify-center relative h-[60px] w-[300px] font-main"
                      onClick={() =>
                        document.getElementById("custom-date").showPicker()
                      }
                    >
                      <input
                        id="custom-date"
                        type="date"
                        name="fecha_perdido"
                        value={formData.fecha_perdido}
                        onChange={handleInputChange}
                        className="custom-date-input font-main text-sm font-medium h-full w-full pl-6 pr-6 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 cursor-pointer shadow-sm"
                      />
                      <FontAwesomeIcon
                        icon={faCalendarAlt}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
                      />
                    </form>
                  </div>
                )}
              </div>
            </section>
          </div>

          <div className="flex flex-col gap-2 text-center w-full pb-6">
            <label className="font-main font-bold text-lg uppercase">
              ¿Donde viste por ultima vez a tu amigo?
            </label>
            <Map
              onMarkerAdded={handleMarkerAdded}
              lat={formData.lat}
              lng={formData.lng}
              zoom={15}
              height={"50dvh"}
            />
          </div>

          <div className="flex flex-col lg:flex-row w-full items-center gap-4 z-10">
            <form className="flex flex-col items-center h-[50dvh] w-[100%] lg:w-[130dvw] font-main font-medium">
              <label className="font-main font-bold text-lg uppercase">
                Descripción
              </label>
              <textarea
                type="text"
                name="descripcion"
                value={formData.descripcion}
                onChange={handleInputChange}
                required
                className="w-full h-full shadow-md text-gray-600"
              />
            </form>

            <div className="flex flex-col justify-center items-center w-full h-[200px] pb-24 p-6">
              {!loading ? (
                <div className="relative inline-block h-16">
                  <button
                    className="flex bg-secondary text-white font-main font-black text-xl leading-[1.75] tracking-[0.02857em] uppercase min-w-[64px] rounded px-4 py-1.5 hover:bg-orange-700 transform transition-transform duration-200 ease-in-out scale-x-100"
                    onClick={edit ? handlePetUpdate : handleUpload}
                  >
                    {location.pathname.startsWith("/editar/")
                      ? "Confirmar tu edición"
                      : "Compartelo con nosotros"}
                  </button>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center">
                  {/* Loader con icono */}
                  <div className="loader">
                    <div className="loader-icon"></div>
                  </div>

                  {/* Mensajes de carga */}
                  {!edit && (
                    <div className="mt-8 h-6 text-center">
                      <p className="font-main font-bold text-secondary animate-pulse">
                        {loadingMessage}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {notification && (
        <Notification
          type={notification?.type}
          message={notification?.message}
        />
      )}

      <div className="w-screen absolute -top-[100px] left-0 overflow-hidden">
        <svg
          width="100%"
          height="100%"
          id="svg"
          viewBox="0 0 1440 490"
          xmlns="http://www.w3.org/2000/svg"
          className="transition duration-300 ease-in-out delay-150 w-[270%] md:w-[100%]"
        >
          <path
            d="M 0,500 L 0,93 C 56.27435897435893,109.58461538461539 112.54871794871787,126.16923076923078 203,127 C 293.45128205128213,127.83076923076922 418.0794871794873,112.9076923076923 500,99 C 581.9205128205127,85.0923076923077 621.1333333333333,72.2 684,63 C 746.8666666666667,53.8 833.3871794871797,48.2923076923077 927,58 C 1020.6128205128203,67.7076923076923 1121.3179487179486,92.63076923076922 1208,101 C 1294.6820512820514,109.36923076923078 1367.3410256410257,101.1846153846154 1440,93 L 1440,500 L 0,500 Z"
            stroke="none"
            strokeWidth="0"
            fill="#499112"
            fillOpacity="0.4"
            className="transition-all duration-300 ease-in-out delay-150 path-0"
            transform="rotate(-180 720 250)"
          ></path>
          <path
            d="M 0,500 L 0,218 C 70.46923076923076,227.3230769230769 140.93846153846152,236.64615384615382 226,230 C 311.0615384615385,223.35384615384618 410.71538461538466,200.73846153846156 488,203 C 565.2846153846153,205.26153846153844 620.1999999999999,232.4 694,228 C 767.8000000000001,223.6 860.4846153846156,187.66153846153847 954,181 C 1047.5153846153844,174.33846153846153 1141.8615384615382,196.95384615384614 1223,208 C 1304.1384615384618,219.04615384615386 1372.069230769231,218.52307692307693 1440,218 L 1440,500 L 0,500 Z"
            stroke="none"
            strokeWidth="0"
            fill="#499112"
            fillOpacity="0.53"
            className="transition-all duration-300 ease-in-out delay-150 path-1"
            transform="rotate(-180 720 250)"
          ></path>
          <path
            d="M 0,500 L 0,343 C 73.82820512820513,328.35128205128206 147.65641025641025,313.70256410256417 218,327 C 288.34358974358975,340.29743589743583 355.2025641025641,381.5410256410256 446,388 C 536.7974358974359,394.4589743589744 651.5333333333332,366.1333333333334 748,360 C 844.4666666666668,353.8666666666666 922.6641025641027,369.92564102564097 1001,363 C 1079.3358974358973,356.07435897435903 1157.8102564102564,326.1641025641026 1231,319 C 1304.1897435897436,311.8358974358974 1372.0948717948718,327.41794871794866 1440,343 L 1440,500 L 0,500 Z"
            stroke="none"
            strokeWidth="0"
            fill="#499112"
            fillOpacity="1"
            className="transition-all duration-300 ease-in-out delay-150 path-2"
            transform="rotate(-180 720 250)"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default CompartirMascota;
